import React from "react";

const ArrowDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M10.3536 6.85355C10.5488 6.65829 10.5488 6.34171 10.3536 6.14645C10.1583 5.95118 9.84171 5.95118 9.64645 6.14645L6.5 9.29289L6.5 1.5C6.5 1.22386 6.27614 1 6 1C5.72386 1 5.5 1.22386 5.5 1.5L5.5 9.29289L2.35355 6.14645C2.15829 5.95118 1.84171 5.95118 1.64645 6.14645C1.45118 6.34171 1.45118 6.65829 1.64645 6.85355L5.64645 10.8536C5.84171 11.0488 6.15829 11.0488 6.35355 10.8536L10.3536 6.85355Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default ArrowDownIcon;
